import React, { useState, useEffect } from 'react';
import Form from './Form'
import Sede from './Sede';
import DatePickerComponent from './DatePickerComponent';
import TimeSelector from './TimeSelector';
import PatientForm from './PatientForm';
import PatientFormInperson from './PatientFormInperson';
import ServiceAditional from './ServiceAditional';
import DatePickerinPerson from './DatePickerComponentInperson';
import TimeSelectorInperson from './TimeSelectorInperson';
import axiosInstance from '../../api/axiosConfig';
import SubscriptionModal from '../SubscriptionModal/SubscriptionModal'; 

export default function Home() {
  const [professional, setProfessional] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const [specialty, setSpecialty] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTimeInPerson, setSelectedTimeInperson] = useState(null);

  const [specialtyInperson, setSpecialtyInperson] = useState(null);
  const [provinceInperson, setProvinceInperson] = useState(null);
  const [departmentInperson, setDepartmentInperson] = useState(null);
  const [districtInperson, setDistrictInperson] = useState(null);
  const [selectedDateInperson, setSelectedDateInPerson] = useState(null);

  const [mode, setMode] = useState("Presencial");
  const [sede, setSede] = React.useState([]);

  // 👇 2. ESTADOS PARA CONTROLAR EL BLOQUEO POR DEUDA
  const [subscription, setSubscription] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const Professionals = async () => {
    try {
      const res = await axiosInstance.get("/api/professionals");
      setProfessional(res.data.data)
    } catch (error) {
      console.log(error)
    }
  } 

  const allSede = async () => {
    try {
      const res = await axiosInstance.get("/api/all-sede");
      setSede(res.data.data)
    } catch (error) {
      console.log(error)
    }
  } 

  
  // FUNCIÓN 
  const checkSubscriptionStatus = async () => {
    // 1. Buscamos si el usuario tiene una sesión activa (Token)
    const token = localStorage.getItem("token");
    
    // 2. Si NO hay token (es un visitante), no hay nada que verificar
    if (!token) return;

    // 3. Decodificar el payload del JWT para obtener el rol sin llamar al backend
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // Solo los usuarios con rol 'personal' tienen cuota de membresía
      if (payload.role && payload.role !== 'personal') return;
    } catch {
      // Si el token es inválido, no mostramos el modal
      return;
    }

    // Si el usuario ya cerró el modal en esta sesión, no lo volvamos a mostrar
    if (sessionStorage.getItem("payment_modal_dismissed")) return;

    // 4. Si SÍ hay token y es personal, vamos al backend a ver si debe pagar
    try {
      const res = await axiosInstance.get("/api/subscription/status");
      setSubscription(res.data);
      
      if (res.data && res.data.status === 'inactive') {
        setShowPaymentModal(true);
      }
    } catch (error) {
      console.error("Error al verificar la suscripción:", error);
    }
  }

  useEffect(() => {
    Professionals();
    allSede();
    checkSubscriptionStatus(); // Ejecutamos la revisión apenas carga el Home
  }, []);
     
  return (
    // Agregamos position relative para asegurar que el modal cubra todo si es necesario
    <div style={{ position: 'relative' }}>
      
      
      <Form allSede={allSede} setMode={setMode} mode={mode} provinceInperson={provinceInperson} departmentInperson={departmentInperson} specialty={specialty} setSpecialtyInperson={setSpecialtyInperson} setDistrictInperson={setDistrictInperson} professional={professional} specialtyInperson={specialtyInperson} setSpecialty={setSpecialty} setDepartmentInperson={setDepartmentInperson} setProvinceInperson={setProvinceInperson} districtInperson={districtInperson}/>
      <Sede allSede={allSede} sede={sede} mode={mode} specialtyInperson={specialtyInperson} provinceInperson={provinceInperson} departmentInperson={departmentInperson} districtInperson={districtInperson} />
      <DatePickerComponent mode={mode} setSelectedDate={setSelectedDate} selectedDate={selectedDate} specialty={specialty}/>
      <DatePickerinPerson allSede={allSede} mode={mode} sede={sede} setSelectedDateInPerson={setSelectedDateInPerson} selectedDateInperson={selectedDateInperson} specialty={specialty}/>
      <TimeSelectorInperson allSede={allSede} selectedTimeInPerson={selectedTimeInPerson} setSelectedTimeInperson={setSelectedTimeInperson} mode={mode} selectedTime={selectedTime} setSelectedTime={setSelectedTime} selectedDate={selectedDate}/>
      <TimeSelector mode={mode} selectedTime={selectedTime} setSelectedTime={setSelectedTime} selectedDate={selectedDate}/>
      <PatientForm mode={mode} specialty={specialty} selectedTime={selectedTime} selectedDate={selectedDate}/>
      <PatientFormInperson allSede={allSede} mode={mode} setSelectedTimeInperson={setSelectedTimeInperson} setDepartmentInperson={setDepartmentInperson} setProvinceInperson={setProvinceInperson} setSpecialtyInperson={setSpecialtyInperson}/>
      <ServiceAditional/>
      
      {/*  EL MODAL BLOQUEADOR AL FINAL DEL COMPONENTE */}
      {subscription && subscription.status === 'inactive' && (
        <SubscriptionModal 
          show={showPaymentModal} 
          status={subscription.status} 
          amountToPay={subscription.amountToPay}
          currency={subscription.currency}
          postalCode={subscription.postalCode}
          onClose={(paid) => {
            setShowPaymentModal(false);
            sessionStorage.setItem("payment_modal_dismissed", "true"); // + AGREGAR
            if (paid) checkSubscriptionStatus(); // Re-verificar tras pago exitoso
          }} 
        />
      )}

    </div>
  );
}